export const Strings = {
    plzInputEmail: "이메일을 입력하세요.",
    plzTypeEmail: "이메일 형식을 확인해 주세요.",
    plzInputPassword: "비밀번호를 입력하세요.",
    loginError: "로그인에 실패했습니다.\n이메일과 비밀번호를 다시 확인해주세요.",
    myAccount: "내 계정",
    logout: "로그아웃",
    userId: "user ID",
    password: "Password",
    saveAccount: "계정 저장",
    accountEmail: "계정(이메일)",
    login: "로그인",
    init: "INIT",
    confirmIdOrPassword: "아이디 또는 비밀번호를 확인해 주세요.",
    changePassword: "비밀번호 변경",
    passwordInitialization: "비밀번호 초기화",
    initialization: "초기화",
    tempPasswordConfirm: "임시 비밀번호 확인",
    initPassword: "초기화 비밀번호",
    passwordInitSuccess: "비밀번호 초기화가 성공하였습니다.",
    passwordInitFail: "비밀번호 초기화가 실패하였습니다.",
    dashboard: "대시보드",
    myShop: "My shop",
    myMenu: "My menu",
    StoreInfo: "매장정보",
    orderKiosk: "주문 키오스크",
    cafeOrderKiosk: "카페 주문 키오스크",
    cafeteriaOrderKiosk: "식당 주문 키오스크",
    ticketKiosk: "식권 키오스크",
    menuBoard: "메뉴보드",
    satisfactionKiosk: "만족도 키오스크",
    pickupBoard: "픽업보드",
    wayFinding: "웨이파인딩",
    dietManagement: "식단 관리",
    productManagement: "상품 관리",
    productDisplayManagement: "전시상품",
    addProductDisplay: "전시상품 추가하기",
    productDisplayAddType: "등록 옵션",
    addNew: "신규등록",
    addProductDisplayFromExist: "기존 전시상품에 추가",
    report: "리포트",
    poll: "설문조사",
    setting: "설정",
    shopInfo: "매장 정보",
    businessManagement: "영업 관리",
    device: "디바이스",
    deviceCount: "디바이스 수량",
    member: "멤버",
    fileStorage: "파일보관함",
    fileManager: "파일 매니저",
    fileUpload: "파일 업로드",
    manualRegisterManagement: "수기등록 관리",
    alarmManagement: "알림 관리",
    ledPickUpManagement: "LED픽업 관리",
    satisfactionContentSetting: "만족도 콘텐츠 설정",
    storeCurrentlyAccessed: "현재 접속중인 매장",
    welcomeEligaOrder: "안녕하세요. ELIGA Store에 오신 걸 환영합니다.",
    downloadPlayer: "ELIGA Player Download",
    kiosk: "키오스크",
    spare: "여유",
    commonly: "보통",
    confusion: "혼잡",
    congestion: "혼잡도",
    spaceSetting: "스페이스 설정",
    space: "스페이스",
    spaceUse: "스페이스 사용현황",
    personnelManagement: "인원 관리",
    employeeManagement: "임직원 관리",
    statisticsLogManagement: "통계/로그 관리",
    statisticsManagement: "매출 통계",
    logManagement: "로그 관리",
    systemManagement: "시스템 관리",
    remoteManagement: "원격 관리",
    distributeManagement: "배포 관리",
    distributeManagementSpace: "배포관리",
    fileManagement: "파일관리",
    versionManagement: "버전관리",
    versionInformation: "버전정보",
    distribute: "배포",
    doDistribute: "배포하기",
    failureNotification: "장애 알림",
    board: "게시판",
    notice: "공지사항",
    manual: "메뉴얼",
    qrCode: "QR코드",
    externalPeopleManagement: "외부인원 관리",
    qrEmployeeIdCardManagement: "QR사원증(기간제) 관리",
    salesManagement: "매출 관리",
    salesStatistics: "매출 통계",
    employeeStatistics: "이용자별 통계",
    pointSystem: "포인트 시스템",
    pointManagement: "포인트 관리",
    pointDetail: "포인트 내역",
    useStatistics: "사용 통계",
    pointSetting: "포인트 설정",
    couponSystem: "쿠폰 시스템",
    couponManagement: "쿠폰 관리",
    couponSetting: "쿠폰 설정",
    stampSystem: "스템프 시스템",
    stampManagement: "스템프 관리",
    boardManagement: "게시판 관리",
    survey: "설문조사",
    termsManagement: "약관 관리",
    memberManagement: "멤버 관리",
    contentsManagement: "콘텐츠 관리",
    categoryManagement: "카테고리 관리",
    optionManagement: "옵션 관리",
    businessStatistics: "영업 통계",
    orderManage: "정산 관리",
    productSalesStatistics: "상품판매 통계",
    manualSalesManagement: "수기매출 관리",
    paymentManagement: "결제 관리",
    unsettledSales: "미정산 매출",
    manualSalesDetail: "수기매출 상세",
    deviceManagement: "디바이스 관리",
    mealTicketKiosk: "식권발급 키오스크",
    menuManagement: "메뉴 관리",
    courseManagement: "코스 관리",
    operationTimeManagement: "운영시간 관리",
    mealQuantityReservationManagement: "식수예약 관리",
    mealQuantityReservationSetting: "식수예약 설정",
    mealQuantityReservation: "식수예약",
    reservationListManagement: "예약리스트 관리",
    settlementManagement: "정산 관리",
    settlementDate: "정산 완료일",
    satisfactionManagement: "만족도 관리",
    satisfactionSetting: "만족도 설정",
    satisfactionSettingApp: "만족도 설정(APP)",
    satisfactionStatistics: "만족도 통계",
    satisfactionStatisticsApp: "만족도 통계(APP)",
    offices: "OFFICES",
    csInfo: "CS: 02-2284-3320 | eligaorder_cs@sqisoft.com",
    address: "서울시 영등포구 선유로 3길 10, 13층",
    downloadInfo: "사내오더 시스템 ELIGA ORDER 소개자료",
    sqisoftName: "에스큐아이소프트(주)",
    no: "No",
    emptyDataComment: '등록된 데이터가 없습니다.',
    emptyListDefaultComment: "리스트가 없습니다.",
    emptyListCompanyComment:
        "등록된 법인 리스트가 없습니다.\n리스트를 확인해주세요.",
    emptyListExternalServiceComment:
        "등록된 외부서비스가 없습니다.\n리스트를 확인해주세요.",
    usedBrand: "사용 브랜드",
    createDateSpace: "스페이스 생성일",
    createDate: "생성일",
    lastUpdateDate: "최종수정일",
    memo: "메모",
    contentsAdd: "등록하기",
    shopCafe: "shop(카페)",
    shopDinner: "shop(식당)",
    brand: "브랜드",
    brandId: "브랜드 ID",
    brandName: "브랜드명",
    shop: "Shop",
    shopType: "Shop Type",
    shopTypeKo: "Shop 유형",
    usedCompany: "사용 법인",
    usedService: "사용 서비스",
    deviceName: "디바이스명",
    orderTerminal: "주문 단말기",
    deviceType: "디바이스 Type",
    usedTemplate: "사용 템플릿",
    deviceGroupManagement: "디바이스 그룹 관리",
    updateDate: "업데이트 일시",
    beforeUpdateDate: "업데이트 일시 (직전)",
    updateHistory: "업데이트 이력",
    historyManagement: "이력관리",
    download: "다운로드",
    failedEmployee: "실패인원",
    downloadDetail: "다운로드(상세)",
    downloadOrder: "다운로드(주문별)",
    downloadGoods: "다운로드(상품별)",
    connectState: "연결상태",
    offReserveTime: "꺼짐 예약 시간",
    powerManagement: "전원관리",
    reboot: "재부팅",
    allBrand: "브랜드 전체",
    allShop: "Shop 전체",
    allShopType: "Shop Type 전체",
    allShopTypeKo: "Shop 유형 전체",
    allDeviceType: "디바이스 유형 전체",
    allConnectState: "연결상태 전체",
    allSelected: "전체 선택",
    allSales: "매출 전체",
    fileName: "파일명",
    fileNameFileVersion: "파일명(운영버전)",
    distributeVersion: "배포버전",
    distributeTime: "배포 시간",
    failureHistory: "장애내역",
    failureDateTime: "장애발생일시",
    allType: "유형 전체",
    allCustomerType: "등록인원 전체",
    customer: {
        internal: {
            base: "임직원",
            working: "임직원 (재직)",
            onLeave: "임직원 (휴직)",
            leave: "임직원 (퇴사)"
        },
        external: {
            base: "외부인원",
            use: "외부인원 (사용)",
            unused: "외부인원 (미사용)"
        }
    },
    title: "제목",
    type: "유형",
    announceTargetBrand: "공지대상(브랜드)",
    announceTargetShop: "공지대상(Shop)",
    postDate: "게시일",
    registrationDate: "등록일",
    registeredDate: "등록일시",
    writer: "작성자",
    isUsed: "사용유무",
    allFile: "파일 전체",
    thumbnail: "썸네일",
    fileType: "파일 유형",
    used: "사용중",
    signup: "가입하기",
    goSignup: "멤버가입 바로가기",
    goCms: "CMS 바로가기",
    list: "리스트",
    dormancyAccount: "휴면계정",
    employeeNumber: "사원번호",
    allCompany: "법인 전체",
    allCompanyRatio: "전체법인(100%)",
    allState: "상태값 전체",
    lastLoginDate: "최종 접속일",
    lastOrderDate: "최종 주문일",
    fcmToken: "FCM(푸시토큰)",
    relationMethod: "연동방식",
    emailCertification: "이메일인증",
    certificationComplete: "인증 완료",
    doCertification: "인증하기",
    email: "이메일",
    subCertificationEmail: "서브 인증 이메일",
    employeeMasking: "사원명 마스킹",
    employeeName: "사원명",
    employeeNameKr: "사원명(한글)",
    employeeNameEn: "사원명(영문)",
    company: "법인",
    rfid: "RFID",
    state: "상태",
    changeDormancyDate: "휴면전환일",
    expectedDeleteAccountDate: "계정삭제일 (예정)",
    lastServerConnectionDate: "서버연동일 (최종)",
    firstServerConnectionDate: "서버연동일 (최초)",
    user: "사용자",
    userName: "사용자명",
    viewCount: "조회수",
    termsType: "약관 Type",
    allProgressState: "진행상태 전체",
    progressState: "진행상태",
    questionCount: "문항수",
    question: "문항",
    participants: "참여자",
    surveyDueDateTime: "설문기간",
    role: "권한",
    account: "계정",
    inviteDateTime: "초대일자",
    joinDateTime: "가입일자",
    dateOfJoining: "가입일",
    allUsed: "사용유무 전체",
    contentName: "콘텐츠명",
    allGroup: "그룹전체",
    selectApplyContents: "적용 콘텐츠 선택",
    byItem: "항목별",
    byOrder: "주문자별",
    byShop: "Shop별",
    byBrand: "브랜드별",
    ratingRanking: "평점순위",
    average: "평균",
    fileAdd: "파일 등록",
    contentsOption: "콘텐츠 옵션",
    contentsCourse: "코스 설정",
    contentsType: "콘텐츠 유형",
    template: "템플릿",
    category: "카테고리",
    registeredExhibitProduct: "등록된 전시상품",
    addExhibitProduct: "전시상품 추가",
    exhibitProduct: "전시 상품",
    exhibitProductName: "전시 상품명",
    productName: "상품명",
    optionMarkName: "옵션 표시명",
    price: "가격",
    priceMainProduct: "가격(대표상품)",
    productDesc: "상품설명",
    orderLimit: "주문제한",
    stockUse: "재고사용",
    modifying: "수정하기",
    spaceName: "스페이스명",
    groupCode: "그룹코드",
    employeeNameDisplay: "사원명 표기",
    employeeLinkedAuto: "임직원 연동(자동)",
    employeeLinkedManual: "임직원 연동(수동)",
    domain: "도메인",
    usedApp: "APP 사용",
    welfareService: "복지 서비스",
    adExposure: "광고 노출",
    usingCompany: "사용 법인",
    unused: "미사용",
    use: "사용",
    nameKo: "한글명",
    nameEn: "영문명",
    point: "포인트",
    coupon: "쿠폰",
    stamp: "스탬프",
    prepaidCard: "선불카드",
    satisfactionSurvey: "만족도 조사",
    allSatisfaction: "만족도 전체",
    satisfactionApp: "만족도 조사 (APP)",
    pgPaidApp: "PG 결제 (APP)",
    pgPaid: "PG 결제",
    kakaoPay: "카카오페이",
    kakaoPayMoney: "카카오페이(머니)",
    kakaoPayCard: "카카오페이(카드)",
    creditCard: "신용/체크카드",
    priceFromCompany: "법인별 상품금액",
    enrollment: "등록",
    registration: "등록하기",
    registrationInfo: "등록정보",
    shopName: "Shop 이름",
    appOpenDate: "APP 오픈일",
    optionFeature: "옵션 기능",
    companyCafeteria: "사내카페",
    companyDinner: "사내식당",
    paidType: "결제 유형",
    paidReason: "결제 사유",
    paymentTime: "결제시간",
    typeKor: "항목 (KOR)",
    kor: "KOR",
    typeEng: "항목 (ENG)",
    eng: "ENG",
    groupSetting: "그룹 설정",
    vncSetting: "VNC 셋팅",
    autoSetting: "자동셋팅",
    callVncSettingValue: "VNC값 불러오기",
    remoteIdUsedList: "리모트 ID 사용 리스트",
    item: "항목",
    settingValue: "설정값",
    paidMethod: "결제 수단",
    cancelPayment: "결제취소",
    addScreenShot: "스크린샷 주기",
    addMonitoringShot: "모니터링 주기",
    customOption: "커스텀 옵션",
    lowOption: "상품 하위 옵션",
    specialOption: "스페셜 옵션",
    singleSelect: "단일선택",
    multiSelect: "복수선택",
    pickupTypeManagement: "픽업유형 관리",
    request: "요청사항",
    pickupType: "픽업유형",
    storePickup: "매장 픽업",
    reservationPickup: "예약 픽업",
    reservationDelivery: "예약 배달",
    robotDelivery: "로봇 배달",
    timeSetting: "시간설정",
    orderAllowCnt: "주문 허용 수량",
    minimumCnt: "최소 주문 수량",
    profile: "프로필",
    using: "사용중",
    baseInformation: "기본정보",
    additionalInformation: "부가정보",
    screenShot: "스크린샷",
    deviceState: "디바이스 상태",
    remoteConnect: "원격연결",
    allView: "전체보기",
    deviceDetailInformation: "디바이스 세부 정보",
    cancel: "취소",
    save: "저장",
    reset: "초기화",
    postingDate: "게시일자",
    announceType: "공지유형",
    announceTarget: "공지대상",
    announceTargetSelect: "공지대상 선택",
    attachFile: "파일첨부",
    content: "내용",
    detailInfo: "상세정보",
    deliverySpace: "배달장소",
    robotDeliverySpace: "로봇배달 장소",
    update: "업데이트",
    categoryName: "카테고리명",
    addedProduct: "등록 상품",
    kioskUseYn: "키오스크 사용",
    mobileUseYn: "모바일 사용",
    mobile: "모바일",
    companyCodeConfirm: "법인코드 확인",
    companyCodeManagement: "법인코드 관리",
    serverConnect: "서버연동",
    modify: "수정",
    addFile: "추가하기",
    addPeopleExcel: "인원추가(엑셀업로드)",
    addPeople: "인원추가",
    companyName: "법인명",
    companyNameKo: "법인명(KOR)",
    companyNameEn: "법인명(ENG)",
    companyCode: "법인코드",
    cardName: "카드명",
    doubleCheck: "중복확인",
    whole: "전체",
    totalCount: "전체 건수",
    settlementPossibleCount: "정산 가능 건수",
    possibleCalcCount: "정산 건수",
    individual: "개별",
    pollDuration: "설문기간",
    pushAlarm: "Push 알림",
    duplicateParticipation: "중복참여",
    singleSelection: "단일선택",
    duplicateSelection: "중복선택",
    shortAnswer: "단답형",
    longSentence: "장문형",
    dateType: "날짜형",
    date: "일자",
    openDate: "운영일",
    gridChoice: "그리드 객관식",
    gridChoiceMultiple: "그리드 객관식 (중복선택)",
    responder: "응답자",
    answer: "응답",
    terms: "이용약관",
    shopMember: "Shop 멤버",
    optionName: "옵션명",
    menuOption: "메뉴옵션",
    groupName: "그룹명",
    distributeContents: "배포 콘텐츠",
    deviceOs: "디바이스 OS",
    deviceTypeKo: "디바이스 타입",
    distributeDate: "배포일자",
    group: "그룹",
    pairing: "페어링",
    getProduct: "상품 불러오기",
    employeeIdCard: "사원증",
    inside: "사내",
    outside: "외부",
    discount: "할인",
    discountCost: "할인가",
    discountAdjustment: "할인 조정액",
    commonPayment: "일반결제",
    courseName: "코스명",
    course: "코스",
    allCourse: "코스전체",
    screenLayout: "화면구성",
    deviceGroup: "디바이스 그룹",
    operationTime: "운영시간",
    originNotation: "원산지표기",
    employeeData: "사원데이터",
    manualOpen: "수동오픈",
    priceSetting: "가격 설정",
    editing: "편집",
    bestWorstStatisticsSetting: "BEST/WORST 통계기간 설정",
    monthly: "월간",
    weekly: "주간",
    stationeryManagement: "문구 관리",
    satisfactionCourseSettings: "만족도 코스 설정",
    screenTransitionSettings: "화면전환 설정",
    satisfactionMenuGroupManagement: "만족도 메뉴그룹 관리",
    satisfactionEvaluationManagement: "만족도 평가 관리",
    appPushNotificationManagement: "APP Push 알림관리",
    employeeIdTaggingPhrase: "사원증 태깅 문구",
    bestWorstStatisticsPhrase: "BEST / WORST 통계 문구",
    satisfactionStatisticsScreen: "만족도 통계 화면",
    bestWorstScreen: "BEST / WORST 화면",
    satisfactionEvaluation: "만족도 평가",
    displaySatisfactionEvaluation: "만족도 평가 노출",
    appDeliveryStandard: "APP 발송기준",
    setSatisfactionScore: "만족도 점수 설정",
    pushNotificationTextSettings: "Push 알림 문구 설정",
    preview: "미리보기",
    notificationStandardScore: "알림기준 점수",
    satisfaction: "만족",
    dissatisfaction: "불만족",
    allOperationTime: "운영시간 전체",
    realTimeCounting: "실시간 집계",
    openingClosingManagement: "개점/마감 관리",
    autoClosing: "자동마감",
    currentTime: "현재시간",
    timeFormat: "시간형식",
    font: "폰트",
    duplicateTagging: "중복 태깅",
    sortRegistrationDate: "등록일순",
    sortFileType: "파일유형순",
    satisfactionTrendCategory: "분류별 만족도 추이",
    byCategory: "분류별",
    byPeriod: "기간별",
    close: "닫기",
    employeeIndividualAdd: "임직원 개별추가",
    delete: "삭제",
    day: "일",
    byDay: "일자별",
    week: "주",
    byMonth: "월별",
    durationPeriod: "기간설정",
    durationDay: "일간",
    durationMonth: "월간",
    durationYear: "연간",
    dietAdd: "식단등록",
    menuName: "메뉴명",
    dietInfo: "식단정보",
    nutritionInfo: "영양정보",
    calorie: "칼로리",
    availableStock: "재고수량",
    salesStock: "판매수량",
    outStockDisplay: "품절표시",
    soldOutYn: "품절여부",
    satisfactionValue: "만족도",
    notUse: "미사용중",
    costSetting: "가격설정",
    cost: "가격",
    won: "원",
    counts: "개",
    publicCost: "일반 가격",
    employeeIdCost: "사원증 가격",
    menuGroup: "메뉴 그룹",
    addMenuGroup: "메뉴 그룹 추가",
    menuGroupList: "메뉴 그룹 리스트",
    tagManagement: "태그 관리",
    addTag: "태그 추가하기",
    tagList: "태그 리스트",
    duplicateTaggingSetting: "중복태깅 설정",
    duplicateTaggingAllowed: "중복태깅 허용 횟수",
    duplicateTaggingInvalidTime: "중복태깅 무효 시간",
    duplicateTaggingUsageCategories: "중복태깅 사용 카테고리",
    duplicateTaggingUsageCourse: "중복태깅 사용 코스",
    app: "APP",
    cms: "CMS",
    pos: "POS",
    calendar: "캘린더",
    today: "오늘",
    searchWeek: "1주",
    searchMonth: "1개월",
    searchPeriod: "기간조회",
    salesStatusPeriod: "기간별 매출현황",
    salesStatusGoodsGroup: "상품 그룹별 매출현황",
    totalByPeriod: "기간별 합계",
    byOperatingHoursPeriod: "운영시간별 매출현황",
    ordersTrendByTimeAndDay: "시간대별 주문건 추이 (요일별)",
    ordersTrendByCorporation: "시간대별 주문건 추이 (법인별)",
    ordersTrendByGoodsGroup: "시간대별 주문건 추이 (상품 그룹별)",
    averageOrdersTrendByTimeAndDay: "시간대별 평균 주문건 추이 (요일별)",
    averageOrderTrendByTimeAndCorporation: "시간대별 평균 주문건 추이 (법인별)",
    averageOrderTrendByTimeAndCategory: "시간대별 평균 주문건 추이 (카테고리별)",
    averageOrderTrendByTimeAndGoodsGroup: "시간대별 평균 주문건 추이 (상품 그룹별)",
    salesByTimeByWeek: "시간대별 판매건 추이 (요일별)",
    salesByTimeByGoodsGroup: "시간대별 판매건 추이 (상품 그룹별)",
    salesByTimeByCorporation: "시간대별 판매건 추이 (법인별)",
    salesAvgByTimeByWeek: "시간대별 평균 판매건 추이 (요일별)",
    salesAvgByTimeByGoodsGroup: "시간대별 평균 판매건 추이 (상품 그룹별)",
    salesAvgByTimeByCorporation: "시간대별 평균 판매건 추이 (법인별)",
    salesAmount: "매출금액 (비율)",
    numberPayments: "결제건수 (비율)",
    orderCountRatio: "주문건수 (비율)",
    paymentNumber: "결제건수",
    orderTypeDivision: "주문 형태별",
    paidMethodDivision: "결제 수단별",
    byCorporation: "법인별",
    on: "ON",
    off: "OFF",
    lastOn: "마지막 켜짐",
    lastOff: "마지막 꺼짐",
    autoOff: "자동 꺼짐",
    weekendSetting: "주말 설정",
    dayOffSetting: "요일별 꺼짐 설정",
    holidaySetting: "공휴일 설정",
    waiting: "대기",
    end: "종료",
    onGoing: "진행중",
    productCode: "상품코드",
    productGroup: "상품그룹",
    salesYn: "판매여부",
    sale: "판매",
    salesNumber: "판매건수",
    displayYn: "노출여부",
    couponUseYn: "쿠폰사용",
    modifyDate: "수정일자",
    addedProductCnt: "등록 상품수",
    maximumCnt: "최대 주문 수량",
    productBarcode: "상품 바코드",
    salesYnAll: "판매여부 전체",
    salesYnTrue: "판매중",
    salesYnFalse: "미판매 (품절)",
    soldOutYnAll: "품절여부 전체",
    soldOutYnTrue: "품절",
    soldOutYnFalse: "판매중",
    salesPeriod: "판매기간",
    salesPeriodSetting: "판매기간 설정",
    categoryAll: "카테고리 전체",
    stockManagement: "재고 관리",
    stockLog: "재고 입출력 관리",
    stockOption: "재고 옵션",
    stockSaveReason: "수정사유",
    count: "수량",
    note: "비고",
    stockSaveReasonAll: "수정사유 전체",
    stockReceipt: "입고",
    stockDamage: "상품훼손",
    etc: "기타",
    etcOpinion: "기타의견",
    product: "상품",
    productImage: "상품 이미지",
    mainProduct: "대표상품",
    productOption: "상품옵션",
    totalType: "누적형",
    resetType: "초기화형",
    everyYear: "매년",
    everyMonth: "매월",
    everyDay: "매일",
    add: "추가",
    resetOptionSettings: "초기화 옵션 설정",
    externalServiceConnect: "외부서비스 연동",
    url: "URL",
    serviceName: "서비스명",
    confirm: "확인",
    alarm: "알림",
    remoteId: "리모트 ID",
    remotePw: "리모트 PW",
    remotePort: "리모트 PORT",
    remoteServerIp: "리모트 서버 IP",
    remoteServerPort: "리모트 서버 PORT",
    usedRemoteIdList: "리모트 ID 사용 리스트",
    paymentAll: "사원증+신용카드",
    copy: "복사",
    move: "이동",
    addStockInfo: "재고 입력",
    badgeOption: "뱃지 옵션",
    currentStock: "현재 재고",
    productRegOrder: "상품등록순",
    productModOrder: "상품수정일순",
    productNameASC: "상품명 ㄱ-ㅎ",
    lastSalePrice: "최종 판매가 : ",
    privacyPolicy: "개인정보 취급방침",
    privacyAccess: "개인정보 접근인증",
    multipleSelectionAllowCnt: "중복선택 허용수량",
    salesState: "판매상태",
    stockQtyOrdering: "재고수량순",
    orderingMove: "순서이동",
    storeName: "매장명",
    manager: "담당자",
    name: "이름",
    contact: "연락처",
    ceo: "대표자",
    businessNumber: "사업자번호",
    addressName: "주소",
    enterAddress: "주소 입력",
    addressChange: "주소 변경",
    addressFind: "주소 찾기",
    employeeRegistrationStatus: "임직원 등록 현황",
    employeeAnnualRegistrationTrend: "임직원 연간 등록인원 추이",
    corporateUsageStatus: "법인별 등록 및 사용현황",
    shopOperationStatus: "Shop 운영현황",
    usageManual: "사용 매뉴얼",
    displayForm: "화면구성",
    realTimeUpdates: "실시간 업데이트",
    lastUpdate: "Last Update",
    todayEn: "Today",
    total: "Total",
    totalDinner: "총 식수",
    android: "Android",
    ios: "iOS",
    orderApp: "ORDER APP",
    kraftonApp: "크래프톤 APP",
    web: "WEB",
    hdd: "저장소",
    allVersion: "운영버전 전체",
    operatingVersion: "운영버전",
    latestVersion: "최신버전",
    targetVersion: "타겟버전",
    distributionTargetVersion: "배포 타겟버전",
    finalInstallationDate: "최종 설치일(운영버전)",
    memberRegistration: "멤버 등록",
    memberResetPwd: "멤버 비밀번호 초기화",
    sendMail: "메일 발송",
    openCloseTime: "개점/마감 시간",
    businessDate: "영업일",
    startBusiness: "영업시작",
    closeBusiness: "영업마감",
    openTime: "개점시간",
    waitingProduct: "대기상품",
    waitingPeople: "대기인원",
    cases: "건",
    serverMatching: "서버매칭",
    computerApplication: "정산적용",
    generalNotice: "일반공지",
    issueAlarm: "장애알림",
    generalPayment: "일반 결제",
    employeeIdPayment: "사원증 결제",
    pointPayment: "포인트 결제",
    nNPeople: "NN명",
    orderStart: "주문 시작하기",
    orderHere: "Order Here",
    seconds: "초",
    contentsTime: "시간",
    connect: "연결",
    disconnect: "연결해제",
    paymentDate: "결제일자",
    paymentInfo: "결제정보",
    orderNumber: "주문번호",
    paymentAmount: "결제금액",
    now: "즉시",
    priority: "우선",
    onSetMenu: "메뉴 등록시",
    onSetTime: "시간 설정",
    surveyClose: "설문종료",
    image: "이미지",
    movie: "동영상",
    file: "파일",
    fileViewer: "파일 보기",
    fivePoint: "5점",
    fourPoint: "4점",
    threePoint: "3점",
    twoPoint: "2점",
    onePoint: "1점",
    bySalesType: "매출유형별",
    byOperatingHours: "운영시간별",
    targetingTastes: "취향저격",
    researchSubjects: "연구대상",
    byPickupType: "픽업 유형별",
    totalSales: "매출액",
    thisMonth: "이번달",
    lastMonth: "지난달",
    nextMonth: "다음달",
    searchDate: "검색기간",
    detail: "상세",
    viewDetails: "상세보기",
    orderQuantity: "주문수량",
    paymentMethod: "결제수단",
    orderStatus: "주문상태",
    orderStatusAll: "주문상태 전체",
    terminal: "단말기",
    terminalAll: "단말기 전체",
    exhibitNo: "전시주문번호",
    buyMeal: "식사 구매",
    afterMinute: "분 후",
    alarmContent: "알림 내용",
    alarmTitle: "알림 제목",
    selectedCompanyCount: "개의 법인이 선택되었습니다.",
    registeredAccount: "등록된 계정",
    discountModiPrice: "할인조정액",
    normalPrice: "일반 판매가",
    idCardPrice: "사원 판매가",
    orderDetail: "주문상세내역",
    totalOrders: "총 주문건",
    totalPayments: "총결제합계",
    paymentsAmount: "결제 합계",
    productQuantity: "상품수량",
    commonPaymentUseYn: '일반결제 노출',
    idcardPaymentUseYn: '사원증결제 노출',
    robotDeliveryAll: '로봇배달 전체',
    couponUseAll: '쿠폰사용 전체',
    goodsGroupAll: "상품그룹 전체",
    selectedOption: '선택옵션',
    productQuantityLimit: '상품 수치 제한',
    loadingCallTime: '상차 호출 시간',
    robotDeliveryPopup: '로봇배달 안내 팝업',
    pieces: '개',
    create: '생성하기',
    robotProductValue: '로봇상품 수치',
    companyPriceAdd: '법인별 사원 판매가 등록',
    goodsPriceSetting: '금액설정',
    salesRecords: "영업기록",
    dailyTotalSales: "일 판매합계",
    dailyAverageSalesLastMonth: "일 평균 매출 (지난달)",
    salesAverage: "판매 평균 (지난달)",
    lastWeekDayN: "지난주 N요일",
    selectAll: "전체선택",
    selectAllAvg: "전체평균",
    salesPriceTotal: "판매 합계",
    monday: "월",
    tuesday: "화",
    wednesday: "수",
    thursday: "목",
    friday: "금",
    saturday: "토",
    sunday: "일",
    highOrderTime: "주문이 많은 시간",
    highOrderTimeByTime: "시간대별 합계 판매 순위",
    lowOrderTime: "주문이 적은 시간",
    numberOfOrders: "주문건수",
    numberOfSales: "판매건수",
    businessHours: "영업시간",
    manufacturingTime: "제조시간",
    byMultiCategory: "카테고리별",
    byGoodsGroup: "상품 그룹별",
    byProduct: "상품별",
    byOption: "옵션별",
    byDate: "일자별 판매 현황",
    byCategorySalesRank: "상품 그룹별 매출 순위",
    byCategoryProductRank: "상품 그룹별 판매 순위",
    byProductSalesRank: "상품별 매출 순위",
    byProductRank: "상품별 판매 순위",
    timeOptionSalesStatus: "시간대별 옵션 판매현황",
    timeTotalSalesStatus: "기간내 총 판매현황",
    dayOptionSalesStatus: "일자별 옵션 판매현황",
    optionMenu: "옵션메뉴",
    averageBusinessHours: "평균 영업시간",
    averageOpeningHours: "평균 개점시간",
    averageClosingTime: "평균 마감시간",
    orderItemManufactureTime: "주문당 상품제조 시간통계 (1건)",
    productItemManufactureTime: "상품당 상품제조 시간통계 (1개)",
    registrationStats: "등록인원 통계",
    serviceUsageStats: "서비스 이용 통계",
    registrationTrendByPeriod: "기간별 등록인원 추이",
    statusByType: "유형별 현황",
    employees: "임직원",
    externalPersonnel: "외부인원",
    qrPeriod: "QR 기간제",
    annual: "연간",
    allPersonnelTypes: "인원유형 전체",
    managementSystem: "관리자 시스템",
    serviceIntro: "서비스 소개",
    inHouseCafe: "사내 카페",
    inHouseCafeteria: "사내 식당",
    shopCafeSaleStatistics: "Shop 매출현황 (사내카페)",
    shopCafeteriaSaleStatistics: "Shop 매출현황 (사내식당)",
    numberOfReorderUsers: "재주문 사용자수",
    salesStatus: "매출현황",
    businessDayAvg: "영업일 평균",
    businessStartDate: "영업개시일",
    businessStart: "영업개시",
    twoDays: "2일",
    salesAmountRatio: "매출금액 (매출비율)",
    corporateType: "법인형",
    allCorporates: "전체법인",
    corporateShopSalesStatus: "법인 전체 Shop별 매출현황",
    corporateSalesStatus: "법인별 매출현황",
    corporateRegistrationTrend: "법인별 등록인원 추이",
    totalPeople: "전체인원",
    autoRegistration: "자동등록",
    manualRegistration: "수동등록",
    manualSales: "수동매출",
    externalPeople: "외부인원",
    qrEmployeeBadge: "QR사원증(기간제)",
    employeeNameKorean: "사원명 (한글)",
    employeeNameEnglish: "사원명 (영문)",
    totalProductQuantity: "총 상품수량",
    totalPaymentSum: "총결제 합계",
    employeeAPI: "임직원 API",
    manualEmployee: "임직원 수동",
    qrTemp: "QR 기간제",
    grandTotal: "총합계",
    statusValue: "상태값",
    peopleType: "인원유형",
    statisticsByUser: "이용자별 통계",
    shopRevenueTotal: "Shop 매출합계",
    deviceTypeOne: "1분할",
    deviceTypeMulti: "다분할",
    employment: "재직",
    leaveOfAbsence: "휴직",
    resignation: "퇴사",
    excelReupload: '엑셀 재업로드',
    employeeAddByExcel: '임직원 엑셀 등록',
    employeeNameOption: {
        nameType: "사원명 표기",
        krName: "한글명",
        enName: "영문명",
    },
    textRegistration: "문구등록",
    textSize: "TEXT 크기",
    textSizeLarge: "크게",
    get: '불러오기',
    loadingZone: '상차지',
    downZone: '하차지',
    serverReflected: '서버적용',
    complete: '완료',
    registerPeopleCount: '등록인원',
    resetPassword: '초기화 비밀번호',
    categoryAdd: '카테고리 등록',
    goodsGroupAdd: '상품 그룹 등록',
    selectType: '선택 유형',
    companyPrice: '법인별 금액',
    useStockStartDt: '재고관리 시작일',
    noSelect: '선택안함',
    selected: '선택한',
    noUse: '사용안함',
    main: '대표',
    mediaOrderChange: "미디어 순서 변경",
    goodsGroup: '상품 그룹',
    displayCategory: '전시 카테고리',
    none: '없음',
    listOrderChange: '리스트 순서 변경',
    sales: '매출',
    salesTotal: '총매출',
    dayAverage: '일평균',
    orderCase: '주문건',
    sellGoods: '판매상품',
    daySalesTotal: '일 판매 합계',
    lastMonthSalesAvg: '판매 평균 (지난달)',
    lastNWeek: '지난주 N요일',
    congestionUse: '혼잡도 사용',
    excelManualSales: '수기매출',
    etcSales: '기타매출',
    totalSalesCount: '총 판매량',
    satisAvg: '만족도 평균점수',
    weekTitle: ['일', '월', '화', '수', '목', '금', '토'],
    lastBusiness: '직전 영업마감 정산일',
    refType: '영업유형',
    refTypeAll: '영업유형 전체',
    stockRemainingQty: '재고 잔여수량',
    moveToGoodsDetail: '상품페이지로 이동',
    employeePoint: '임직원별 포인트',
    pointTransactionHistory: '지급 및 회수 관리',
    pointTransaction: '지급/회수',
    pointAmount: '보유 포인트',
    lastPaidAt: '마지막 지급일시',
    showUncreditedPointEmployees: '포인트 미지급자 보기',
    selectedPersonCounts: '선택 인원(명)',
    usingPoint: '포인트 사용',
    pointGiveAndInitSetting: '포인트 지급 및 초기화 설정',
    quarterly: '분기별 (1, 4, 7, 11월)',
    halfYearly: '반기별 (1, 7월)',
    everyYearly: '매년 (1월)',
    nonePointGive: '지급 없음',
    nonePointInit: '초기화 없음',
    lastUpdateDay: '마지막 업데이트',
    useAutoGive: '자동 지급 사용',
    giveAndInit: '지급 및 초기화',
    pointSum: '포인트 금액',
    give: '지급',
    division: '구분',
    divisionAll: 'APP 상태 전체',
    reasonContent: '내용(사유)',
    transactionPoint: '지급/회수 포인트',
    balancePoint: '보유 포인트',
    qty: '건',
    pointRewardEarn: '적립',
    pointRewardChangeItem: '충전(개별)',
    pointRewardChangeAuto: '충전(자동)',
    pointRewardChangeExcel: '충전(엑셀)',
    pointRewardUse: '사용',
    pointRewardExpire: '소멸',
    pointRewardRefund: '환불',
    pointRewardPending: '보류',
    pointRewardTransfer: '이전',
    pointRewardRetrieve: '회수',
    pointRewardRetrieveManual: '회수(개별)',
    pointRewardRetrieveExcel: '회수(엑셀)',
    pointRewardAnnualExpire: '1년마다 소멸',
    pointRewardAnnualRenewal: '1년마다 갱신',
    pointRewardNone: '없음',
    payoutMethod: '지급 방식',
    processState: '진행 상태',
    pointTransactionCompDate: '지급 일시',
    payoutUserCount: '지급 인원',
    dataSetAvailablePeopleCount: '적용 가능 인원',
    dataSetCompPeopleCount: '완료 인원',
    pointTransactionDetail: '지급/회수 상세',
    pointTransactionDetailExcel: '지급/회수(EXCEL) 상세',
    pointTransactionRegister: '지급/회수 등록하기',
    employeeSearch: '임직원 검색',
    payoutDate: '지급일자',
    pointTransactionReason: '지급/회수 사유',
    pointTransactionAmount: '지급/회수 포인트',
    target: '적용 대상',
    individualPointTransaction: '개별 지급/회수',
    applyPoint: '포인트 적용',
    person: '명',
    companyPointSetting: '법인별 포인트 설정',
    paidPoint: '지급 포인트',
    duplicateData: '중복 데이터',
    autoRegistered: '자동',
    excelRegistered: '수동(EXCEL)',
    manualRegistered: '수동(개별)',
    companyPoint: '법인별 포인트',
    showOrderDetail: '주문 상세보기',
    moreThanOnce: '회 이상',
    reOrderCounts: '재주문 건수',
    closedDate: '휴무일',
    appEmployeeIdSetting: '모바일 사원증 설정',
    employeeIdBarcode: '바코드 (1D)',
    employeeIdQrCode: 'QR코드 (2D)',
    employeeCodeType: '코드 모양',
    employeeCodeValidTime: '유효시간(초)',
    shopCopy: 'Shop 상품 복사',
    sourceShop: '기준 Shop',
    targetShop: '적용 Shop',
    shopCopyGoodsLimitExceeded: '선택한 Shop에 등록된 상품이 5개를 초과했습니다.',
    shopNotExist: '선택한 Shop 정보가 없습니다.',
    shopCantCopyIntoSameShop: '기준 Shop과 동일한 Shop은 선택할 수 없습니다.',
    fit: {
        option: "맞춤옵션",
        cover: "채우기",
        fill: "채우기 (비율무시)",
        contain: "틀 안에 맞추기",
        none: "원본크기",
    },
    animation: {
        option: "애니메이션 효과",
        none: "효과없음",
        appear: "나타나기",
        leftToRight: "왼쪽에서 오른쪽으로 슬라이드",
        rightToLeft: "오른쪽에서 왼쪽으로 슬라이드",
        bottomToTop: "아래에서 위로 슬라이드",
        topToBottom: "위에서 아래로 슬라이드",
    },
    changeMode: {
        imageChange: "이미지 전환",
        autoMode: "자동모드",
        scheduling: "스케줄링",
    },
    summery: {
        dashboard: "안녕하세요. Master 님. 사내오더 시스템  ELIGA Order 관리자페이지에 오신걸 환영합니다.",
        welcome: "안녕하세요. 사내오더 시스템 ELIGA ORDER에 오신걸 환영합니다.",
        space: "브랜드 연동정보를 편집하거나, Shop/ 디바이스 정보를 등록, 삭제, 편집 기능을 제공합니다.",
        employee: "브랜드에 API로 연동된 임직원(사용자) 정보를 관리합니다. 삭제/등록 기능은 제공하지 않습니다.",
        systemRemote: "각 스페이스에 등록된 디바이스의 플레이 상태와 원격접속 기능을 지원합니다.",
        systemDistribute: "현장 디바이스에 시스템이 배포된 이력을 관리합니다.",
        systemFailure: "Player 장애 발송 내역을 관리합니다.",
        notice: "브랜드 또는 Shop에 공지할 게시글 내역을 관리합니다. 공지대상으로 브랜드 또는 shop을 개별 선택할 수 있습니다.",
        manual: "사용 메뉴얼을 관리합니다.",
        storage: "관리자시스템에서 사용한 파일을 저장, 삭제, 검색하는 기능을 제공합니다. 파일보관함에 등록된 파일은 관리자 시스템내에 어디에서든 재사용이 가능합니다.",
        statLog: "임직원/외부인원으로 등록된 인원현황과, 각 브랜드별로 서비스를 이용한 이용 내역에 대한 통계를 제공합니다.",
        log: "시스템 사용 로그를 관리합니다.",
        realTimeInfoCaption: "현재 영업중인 실시간 주문데이터로 제공됩니다. 영업이 마감되면 정산 매출데이터로 집계되어 기간조회 화면에서 조회 가능합니다. (직전 영업마감 정산일 : YYYY.MM.DD TT:MM:SS)",
        serverMatchingCaption: "서버매칭 : 성공: {successText} / 실패: {failText}",
        brand: {
            employee: "ELIGA Order 사용 임직원을 API를 통해 자동 연동하거나, 직접 엑셀로 수기 등록, 수정, 삭제 합니다. 등록된 개인정보는 암호화 처리되며, 상태값 기준으로 정렬됩니다.",
            employeeList: "최종업데이트 : {cmsModAt} (CMS) / {serverModAt}",
            employeeExternal: "ELIGA Order 사용할 수 있는 외부인원 임시카드 를 등록, 수정, 삭제 합니다. 임시카드로는 APP 서비스 가입이용이 제한됩니다.",
            board: "임직원들에게 공지할 게시글 내역을 관리합니다. 전체 또는 shop을 지정해 공지를 할 수 있고, 공지내역은 APP에 노출됩니다.",
            survey: "설문지 등록 및  응답 통계를 관리 합니다.",
            terms: "임직원 회원가입시 APP에 노출되는 약관을 관리합니다. 서비스 이용과 개인정보 취급방침 등 사규에 맞춰 약관을 등록, 수정 기능을 제공합니다.",
            member: "브랜드에 접근가능한 멤버를 초대하거나,  Super 멤버에게 Shop 접근 권한을 추가/수정/삭제하는 기능을 제공합니다. ",
            inviteMember: "입력된 메일로 멤버가입 URL이 전송됩니다.",
            saleStatistics: "Shop별 통합 매출 및 법인별 매출 통계 리스트를 제공합니다. 통계는 24개월까지만 제공됩니다.",
            pointManagement: "임직원별 포인트 보유 및 사용 현황을 알 수 있으며, 필요에 따라 직접 포인트를 지급/회수할 수 있습니다.",
            pointSetting: '매월 1일 정기적으로 임직원에게 부여하는 포인트를 설정할 수 있습니다. 설정을 변경하는 경우 변경한 설정값은 다음달부터 적용됩니다.',
        },
        dining: {
            orderKiosk: "식당에 사용하는 주문키오스크 단말기의 미운영 시간에 표출할 대기화면 콘텐츠를 관리합니다.",
            menuBoard: "식당에 사용하는 메뉴보드 단말기의 미운영 시간에 표출할 대기화면 콘텐츠를 관리합니다.",
            wayFinding: "식당에 사용하는 웨이파인딩 단말기의 미운영 시간에 표출할 대기화면 콘텐츠를 관리합니다.",
            ticket: "식당에 사용하는 식권발급 단말기의 미운영 시간에 표출할 대기화면 콘텐츠를 관리합니다.",
            satisfaction: "식당에 사용하는 만족도 키오스크 단말기의 미운영 시간에 표출할 대기화면 콘텐츠를 관리합니다.",
            menu: "카테고리(코스)의 메뉴를 일자별로 등록 관리합니다.",
            course: "사내식당에 운영할 코스를 등록하거나,  코스의 판매가격을 설정할 수 있습니다.",
            operationTime: "사내식당의 전체 운영시간을 관리합니다. 운영시간은 제한없이 추가 가능합니다.",
            satisfactionSetting: "만족도 키오스크에 표시할 콘텐츠를 설정합니다.",
            satisfactionSettingApp: "식당 이용내역 만족도(APP) 서비스를 설정하는 화면입니다.",
            satisfactionStatistics: "사용자가 참여한 만족도 통계를 제공합니다.",
            businessSetting: "매장정보와 매장 영업 설정을 관리합니다.",
            deviceSetting: "Shop에 설치된 디바이스 셋팅 및 원격제어 기능을 제공합니다.",
            member: "식당에 접근가능한 멤버를 초대하거나,  Super 멤버에게 Shop 접근 권한을 추가/수정/삭제하는 기능을 제공합니다. ",
            manualSalesManagement:
                "수기로 발생된 매출을 입력해 정산에 반영하는 기능을 제공합니다. 수기데이터는 엑셀로 등록하고, 데이터는 임직원의 이메일(계정)으로 서버와 매칭됩니다.",
            businessStatistics: "영업시간대별 매출추이, 상품 제조 시간 및 영업시간 통계를 제공합니다. 리포트는  24개월까지 제공하며, 최대 3개월 단위로 조회 가능합니다.",
        },
        cafe: {
            businessManagement: "매장 정보와 매장 영업 설정을 관리합니다.",
            goodsManagement: '카페 상품과 상품별 주문옵션을 등록, 관리합니다. 등록된 상품은 POS, 주문키오스크 메뉴보드와 연동됩니다.',
            categoryManagement: '상품 카테고리 옵션을 등록, 수정, 삭제 관리합니다. 모바일과 키오스크에 사용 on/off를 설정할 수 있습니다.',
            optionManagement: '상품선택 시 필요한 옵션상품을 등록, 수정, 삭제 관리합니다. 등록된 옵션은 별도 통계를 제공하며, 미사용 옵션은 통계데이터에서 제외됩니다.',
            stockManagement: '상품 입고/출고 내역과 재고수량을 관리합니다. 상품리스트는 상품관리에 등록된 상품리스트를 받아옵니다.',
            pickupTypeManagement: "카페에서 사용할 상품 픽업 유형을 관리합니다. ON으로 표시된 픽업 유형 서비스가 고객에게 노출됩니다.",
            requestManagement: "상품 주문시 주문하기 페이지에서 고객 요청사항을 입력할 수 있는 칸이 노출됩니다.",
            storePickup: "매장에서 직접 상품을 전달합니다.",
            reservationPickup: "고객이 지정한 픽업시간에 맞춰\n 현장에서 상품을 전달합니다.",
            reservationDelivery: "고객이 지정한 픽업시간에 맞춰\n 지정된 배송지에 상품을 전달합니다.",
            robotDelivery: "고객이 지정한 배달장소에\n 로봇이 상품을 전달합니다.",
            pieceProductSelected: "개의 상품이 선택되었습니다.",
            productOrderQty: "상품 주문 최소/최대 수량을 설정합니다.",
            productStockQty: "재고수량과 판매수량을 관리하며, 재고가 소진되면 자동 품절처리됩니다.",
            lowOptionSetting: "상품 하위옵션은 별도 통계를 제공하며 상품에 1개의 옵션만 설정 가능합니다.",
            saleStatisticsReport: "매출 통계리포트 및 정산관리 기능을 제공합니다. 리포트는  24개월까지 제공하며, 최대 3개월 단위로 조회 가능합니다.",
            saleStatisticsV2Report: "영업일 실시간 주문데이터와 정산이 완료된 매출통계 리포트 기능을 제공합니다. 매출통계 리포트는 24개월까지 제공되며, 최대 2개월 단위로 조회 가능합니다.",
            orderReport: "결제관리 기능을 제공합니다. 최대 3개월 단위로 조회 가능합니다.",
            member: "카페에 접근가능한 멤버를 초대하거나,  Super 멤버에게 Shop 접근 권한을 추가/수정/삭제하는 기능을 제공합니다. ",
            product: "상품 판매와 옵션 통계 데이터를 제공합니다. 리포트는  24개월까지 제공하며, 최대 3개월 단위로 조회 가능합니다.",
            stock: {
                common1: "개 입고되었고",
                common2: "개 출고되었습니다.",
                common3: "개 재고가 남아있습니다.",
                common4: "재고를 수정하시겠어요?",
                common5: "개 추가(삭제)됩니다.",
                common6: "수정 사유를 입력해주세요.",
                common7: "선택유형을 변경하시겠습니까?",
                common8: "옵션의 선택 유형을 변경하는 경우 설정된 옵션과 누적 통계가 초기화되며, 재설정이 필요합니다.",
                total1: "재고관리 사용일로부터",
                total2: "*누적형: 재고사용일로부터 상품의 입고, 출고(판매) 수량이 누적되어 관리됩니다.",
                reset1: "지정된 일자에",
                reset2: "에 입고/판매(출고) 수량이 초기화 되고",
                reset3: "개 상품이 재입고 됩니다.",
                reset4: "*초기화형: 설정된 일자에 맞춰 상품의 입고, 출고(판매)수량이 초기화되고 상품 자동 재입고로 관리됩니다.",
                reset5: "초기화 옵션 재고설정을 변경합니다.",
                reset6: "에 입고/판매(출고) 수량이 초기화 되고",
                reset7: "개의 상품이 자동 재입고 됩니다.",
                reset8: "초기화 옵션설정이 변경되면 누적된 재고이력이 삭제되며, 설정된 설정값으로 새롭게 누적됩니다.",
            },
            companyOptionPrice: "법인별로 가격을 등록합니다.",
            productDetailStock: "상품재고와 판매수량을 관리하며, 재고가 소진되면 자동 품절처리됩니다."
        },
    },
    desc: {
        noExhibitProductToShow: "등록된 전시상품이 없습니다.\n전시상품을 등록해 상품을 노출해주세요.",
        contentEmptyMsg: "등록된 콘텐츠가 없습니다.",
        robotPlaceEmptyMsg: "등록된 하차지가 없습니다.",
        plzSearchText: "검색어를 입력하세요",
        manageStandbyKiosk: "키오스크에 미반영 시간에 노출될 대기화면 콘텐츠를 관리합니다.",
        manageMarketingMenuBoard: "메뉴보드에 노출될 메뉴 이미지 외 홍보 콘텐츠(영상, 이미지)를 관리합니다.",
        manageStandbyPickupBoard: "픽업 보드에 노출될 대기화면 콘텐츠를 관리합니다.",
        manageStandbyWayFinding: "웨이파인딩에 노출될 대기화면 콘텐츠를 관리합니다.",
        storageGuide: "시스템 환경을 위해 사용하지 않는 파일을 주기적으로 삭제해 주세요.",
        welcomeManager: "안녕하세요, 관리자님.",
        loginTitle: "가입한 계정정보를 입력해주세요.",
        initTitle: "브랜드 코드를 입력해 주세요.",
        joinMemberByButton: "버튼을 눌러 멤버가입을 진행해 주세요.",
        inviteShopMember: "에\nCMS 관리자 멤버로 초대되었습니다.",
        expiredInviteMember: "멤버초대 세션이 만료되었습니다.",
        plzConnectManager: "매장 관리자에게 문의해 주세요.",
        completeRegistration: "멤버가입이 완료되었습니다.",
        cafePaidType: "카페 주문키오스크+사원증 결제시 나오는 항목입니다.\n미설정시 사원증 결제 화면에서 나오지 않습니다.",
        cafeBusiTimeSetting: "예약픽업이 가능한 시간을 설정해주세요.",
        cafeDeliveryTimeSetting: "예약배달이 가능한 시간을 설정해주세요.",
        cafeBusiOrderCnt: "주문수 기준이며, 예약픽업시간에 허용된 수량의 예약이 되면 해당 시간은 자동으로 비활성화 됩니다.",
        cafeBusiMinimumCnt: "1건의 주문에 최소 상품 주문 수량을 설정합니다. 설정된 개수 이하는 예약배달이 불가능 합니다.",
        titleDisplayOrderKiosk: "주문키오스크에 표출되는 타이틀입니다.",
        diningStatisticsWeekDuration: "주간 : 전주 월요일 ~ 일요일 데이터",
        diningStatisticsMonthDuration: "월간 : 전월 1일 ~ 30일  데이터",
        menuGroupsHaveRegistered: "개의 메뉴 그룹이 등록되었습니다.",
        tagHaveRegistered: "개의 태그가 등록되었습니다.",
        satisfactionMenuAppPushRegisteredMenuGroup: "등록된 메뉴 그룹의 키워드에 맞춰 만족도 메뉴 알림 APP Push가 발송됩니다.",
        includingOperationMenu: "운영중 메뉴 포함",
        satisfactionEvaluationDisplayedOperatingMenu: "현재 운영중인 메뉴에 만족도 평가를 실시간으로 노출합니다.",
        manageServiceOptionAvailable: "식당에서 사용할 서비스 옵션을 관리합니다. ON으로 표시된 설정된 서비스가 고객에게 노출됩니다.",
        employeeIdDuplicatePayment: "동일한 식당 운영시간안에 \n사원증 중복결제 서비스를 제공합니다.",
        selected: "개 선택되었습니다.",
        priceSetOrderKioskNotDisplayed: "주문키오스크에 설정된 가격을 노출하지 않습니다.",
        priceRegisteredCorporation: "법인별로 가격을 등록합니다.",
        duplicateTaggingAllowed: "동일 운영시간 (ex) 점심운영시간)에 사원증 재구매가 가능한 중복태깅 허용 횟수를 설정합니다.",
        duplicateTaggingInvalidTime: "연속으로 중복태깅시 중복태깅을 무시하는 시간을 설정합니다. (사용자 과실로 인한 중복 결제 방지)",
        duplicateTaggingUsageCategories: "중복태깅 사용 가능한 카테고리를 설정 합니다.",
        duplicateTaggingUsageCourse: "중복태깅 사용 가능한 코스를 설정 합니다.",
        noFileDesc: "등록된 파일이 없습니다.",
        brandCompanyDisplay: "법인 미사용시 법인 관련 메뉴는 브랜드 사이트에 노출되지 않습니다.",
        externalServiceDisplay: "외부 서비스 연동 미사용시 관련 메뉴는 사용자 APP에 노출되지 않습니다.",
        deviceAddDinningTemplate: "* 전면 식단정보, 후면 식수 카운팅 콘텐츠가 제공되는 템플릿 입니다.",
        deviceAddCafeTemplate: "* 기본 테마 디자인이 적용되는 카페 주문 키오스크 템플릿 입니다.",
        monthlyDataNote: "매월 말일자 데이터 기준으로 12개월 데이터가 집계됩니다. (지난달 기준)",
        userMonthlyDataNote: "매월 말일 데이터 기준으로 집계됩니다",
        plzPaymentMethodSelect: "결제수단을\n선택해주세요",
        checkConfirmPassword: "비밀번호가 다릅니다. 다시 확인해주세요.",
        checkOldAndNewPassword: "이전 비밀번호와 다른 비밀번호로 사용해주세요.",
        checkPasswordRule: "비밀번호 형식을 확인해주세요 (영문, 숫자, 특수문자 중 2종류 이상 + 10~20 자리)",
        checkPasswordRuleChar: "비밀번호 형식을 확인해주세요 (영문, 숫자, 특수문자(?!@&^~*#$+=) 중 2종류 이상)",
        checkAppPasswordRule: '비밀번호는 영문, 숫자, 특수문자(?!@&^~*#$+=)를 포함한 8자 이상으로 설정 가능합니다.',
        checkAppPasswordSameChar: '동일 문자(글자, 숫자, 기호)는 연속 세 번 이상 반복할 수 없습니다.',
        checkPasswordRuleLength: "비밀번호 길이를 확인해주세요 (10~20 자리)",
        plzEnterPassword: "비밀번호를 입력해주세요",
        timeOptionGuidance: "시간대별 옵션 판매 현황은 그래프 옵션 개별로만 제공됩니다.",
        numberOrder: "각 브랜드에서 결제된 주문건수를 결제 항목별로 통계를 제공합니다.",
        optionSingleSelect: '* 1개만 선택 가능한 옵션메뉴입니다.',
        optionMultiSelect: '* 여러 개 선택 가능한 옵션메뉴입니다.',
        displayCategoryMove: '선택한 전시 상품을 아래 카테고리로 이동합니다.',
        contentsCourseCount: '다분할 코스는 1개만 설정 가능합니다.',
        congestionUsageInApp: '코스별 혼잡도 콘텐츠를 표시합니다.\n(APP)',
        noOperationTime: '현재 운영중인 시간이 없습니다.',
        addNewProductDisplayInfo: '신규로 등록할 전시상품 정보를 입력해주세요.',
        limitTimeMoreThen: '최소 10초부터 입력해주세요.',
        limitTimeLessThen: '최대 180초까지 입력이 가능합니다.',
        fileManager: [
            '여기로 이미지를 드래그하거나',
            '파일을 업로드하세요.'
        ],
        statistics: [
            "매출 = 총매출액 - (할인+결제취소)",
            "총매출 = 상품의 판매로 발생된 전체 매출로 상품의 판매가격 + 옵션가 (할인가와 결제취소를 더하지 않은 매출)",
            "일평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
            "결제취소 : 정산 및 주문이 완료된 주문이 결제최소가 되어 마이너스 매출로 발생된 금액입니다.",
            "실시간으로 업데이트된 오늘날짜 영업매출은 마감전 데이터로, 마감후 정산처리가 완료되면 매출 내역은 달라질 수 있습니다.  (정산시간: 개점~마감 기준으로 다음날 이전일 영업중 데이터가 없을 때  ex) 5/15개점 ~ 5/16 마감시 5/15 매출 정산)",
            "시스템 정산 및 실시간 업데이트 데이터 반영은 약 5분 ~ 10분정도 소요될 수 있습니다",
            "과거 날씨는 매일 오전 10시에 업데이트 됩니다. (오전 기온 08시, 오후 기온 17시, 미세먼저 농도 08시 기준)"
        ],
        statisticsV2: {
            calendar: [
                "총매출 = 상품의 판매로 발생된 전체 매출로 상품의 판매가격 + 옵션가 (할인가와 결제취소를 더하지 않은 매출)",
                "매출 = 총매출액 - (결제취소+할인조정액)",
                "사원가 할인 조정액 : 상품의 원 판매가격에서 사원판매가로 조정된 할인 금액",
                "일평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
                "결제취소 : 정산 및 주문이 완료된 주문이 결제최소가 되어 마이너스 매출로 발생된 금액으로, 결제가 기준이 아닌 일반판매가로 취소되며 할인조정액이 있는 경우 조정된 할인금액은 원복됩니다.",
                "실시간으로 업데이트된 영업일 (영업중) 매출은 정산되지 않은 영업마감전 데이터로, 영업 마감후 정산처리가 완료되면 매출 내역은 달라질 수 있습니다.  (정산시간: 개점~마감 기준으로 다음날 이전일 영업중 데이터가 없을 때  ex) 5/15개점 ~ 5/16 마감시 5/15 매출 정산)",
                "시스템 정산 및 실시간 업데이트 데이터 반영은 약 5분 ~ 10분정도 소요될 수 있습니다"
            ],
            sales: [
                "총매출 = 상품의 판매로 발생된 전체 매출로 상품의 판매가격 + 옵션가 (할인가와 결제취소를 더하지 않은 매출)",
                "매출 = 총매출액 - (결제취소+할인조정액)",
                "사원가 할인 조정액 : 상품의 원 판매가격에서 사원판매가로 조정된 할인 금액",
                "일평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
                "결제취소 : 정산 및 주문이 완료된 주문이 결제취소가 되어 마이너스 매출로 발생된 금액으로, 결제가 기준이 아닌 일반판매가로 취소되며 할인조정액이 있는 경우 조정된 할인금액은 원복됩니다.",
                "실시간으로 업데이트된 영업일 (영업중) 매출은 정산되지 않은 영업마감 전 데이터로 영업 중일 때만 조회 가능합니다.",
                "영업 마감된 이후에는 정산처리가 진행되며, 매출통계 (기간조회)에서 매출 데이터를 확인할 수 있습니다. (정산시간: 영업 마감 시점, 동일일에 여러 번 개점/마감을 했을 때 또는 영업일 다음 날을 넘겼을 때는 영업 개점일 기준으로 정산 데이터가 집계됩니다. ex) 5/15 개점 ~ 5/16 마감 시 5/15 매출 정산)",
                "시스템 정산 및 실시간 업데이트 데이터 반영은 약 5분 ~ 10분 정도 소요될 수 있습니다.",
                "주문건수는 주문된 결제건수로 제공합니다."
            ],
            business: [
                "영업매출은 검색기간의 평균 데이터로 제공 되며, 요일별, 시간대별로 매출 비교가 가능 합니다.",
                "총매출 = 상품의 판매로 발생된 전체 매출로 상품의 판매가격 + 옵션가 (할인가와 결제취소를 더하지 않은 매출)",
                "매출 = 총매출액 - (결제취소+할인조정액)",
                "사원가 할인 조정액 : 상품의 원 판매가격에서 사원판매가로 조정된 할인 금액",
                "일평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
                "결제취소 : 정산 및 주문이 완료된 주문이 결제최소가 되어 마이너스 매출로 발생된 금액으로, 결제가 기준이 아닌 일반판매가로 취소되며 할인조정액이 있는 경우 조정된 할인금액은 원복됩니다.",
                "실시간으로 업데이트된 영업일 (영업중) 매출은 정산되지 않은 영업마감전 데이터로 영업중일 때만 조회 가능가 가능합니다.",
                "영업 마감된 이후에는 정산처리가 진행되며, 매출통계 (기간조회)에서 매출데이터를 확인할 수 있습니다. (정산시간: 영업 마감시점,  동일일에 여러번 개점/마감을 했을 때 또는 영업일 다음날을 넘겼을때는 영업 개점일 기준으로 정산 데이터가 집계됩니다.  ex) 5/15개점 ~ 5/16 마감시 5/15 매출 정산)",
                "시스템 정산 및 실시간 업데이트 데이터 반영은 약 5분 ~ 10분정도 소요될 수 있습니다.",
                "주문건수는 주문된 결제건수로 제공합니다.",
            ],
            manufacturing: [
                "주문제조 통계는 정산이 완료된 데이터로 통계치를 반영합니다.",
                "제조상품 여부와 관계없이 판매되는 모든 상품을 평균치로 정상적인 주문 4단계를 거친 주문건만 제조시간 통계를 제공됩니다.",
                "주문취소건은 통계에서 제외, 주문완료이 완료된 건만 집계됩니다. (결제취소건 포함)",
                "해당 통계는 매장픽업 유형만 집계되며, 예약픽업/ 배달예약/ 로봇배송 등 전체 제조과정 시간 측정이 어려운 픽업유형은 제외 됩니다."
            ],
            product: [
                "총매출 = 상품의 판매로 발생된 전체 매출로 상품의 판매가격 + 옵션가 (할인가와 결제취소를 더하지 않은 매출)",
                "매출 = 총매출액 - (결제취소+할인조정액)",
                "영업일 평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
                "상품 판매가격이 변동된 경우 변동된 최종가격으로 표시되며, 매출액은 정산이 완료된 데이터로 판매된 일자의 상품가격을 따라 매출에 반영됩니다."
            ],
        },
        cafeStatistics: [
            "총매출 = 상품의 판매로 발생된 전체 매출로 상품의 판매가격 + 옵션가 (할인가와 결제취소를 더하지 않은 매출)",
            "매출 = 총매출액 - ((-)결제취소+(-)할인조정액)",
            "사원가 할인 조정액 : 상품의 원 판매가격에서 사원판매가로 조정된 할인 금액",
            "일평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
            "결제취소 : 정산 및 주문이 완료된 주문이 결제최소가 되어 마이너스 매출로 발생된 금액으로, 결제가 기준이 아닌 일반판매가로 취소되며 할인조정액이 있는 경우 조정된 할인금액은 원복됩니다.",
            "실시간으로 업데이트된 영업일 (영업중) 매출은 정산되지 않은 영업마감전 데이터로, 영업 마감후 정산처리가 완료되면 매출 내역은 달라질 수 있습니다. (정산시간: 개점~마감 기준으로 다음날 이전일 영업중 데이터가 없을 때  ex) 5/15개점 ~ 5/16 마감시 5/15 매출 정산)",
            "시스템 정산 및 실시간 업데이트 데이터 반영은 약 5분 ~ 10분정도 소요될 수 있습니다.",
        ],
        brandStatistics: [
            "매출 = 총매출액 - (결제취소+할인조정액)",
            "영업일 평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
            "결제취소 : 정산 및 주문이 완료된 주문이 결제최소가 되어 마이너스 매출로 발생된 금액입니다.",
            "영업일 : 검색기간애에 매장 영업을 진행한 일자를 표시합니다. 매장 영업일은 영업개시일을 기준으로 표시됩니다. (당일 오픈 ~ 다음날 마감인 경우 당일 1일로 인정)",
            "Active 사용자 : 검색기간내에 매장에 방문한 실사용자 수를 표시합니다. 중복방문을 제거한 방문 사용자 입니다."
        ],
        brandStatisticsShop: [
            "총매출 = 상품의 판매로 발생된 전체 매출로 상품의 판매가격 + 옵션가 (할인가와 결제취소를 더하지 않은 매출)",
            "매출 = 총매출액 - (결제취소+할인조정액)",
            "사원가 할인 조정액 : 상품의 원 판매가격에서 사원판매가로 조정된 할인 금액",
            "일평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
            "모든 정산 데이터는 영업 마감된 이후에 진행되며, 매출통계 (기간조회)에서 매출데이터를 확인할 수 있습니다. (브랜드에서 실시간 매출 현황은 제공되지 않습니다. 실시간 매출은 각 shop에서 확인 가능합니다.)",
            "시스템 정산 및 실시간 업데이트 데이터 반영은 약 5분 ~ 10분정도 소요될 수 있습니다"
        ],
        brandStatisticsCorporation: [
            "총매출 - (결제취소+할인조정액) = 매출",
            "매출비율은 전체 매출에서 법인별 매출을 100의 비율로 환산하여 표시됩니다.",
            "정산이 완료된 매출 데이터로 제공됩니다."
        ],
        brandStatisticsOrder: [
            "정산이 완료된 매출 데이터로 제공됩니다."
        ],
        diningBusiness: [
            "매출정산 기준으로 데이터를 제공합니다.",
            "영업일 평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
            "결제취소 : 정산 및 주문이 완료된 주문이 결제최소가 되어 마이너스 매출로 발생된 금액으로, 결제가 기준이 아닌 일반판매가로 취소되며 할인조정액이 있는 경우 조정된 할인금액은 원복됩니다.",
            "실시간으로 업데이트된 영업일 (영업중) 매출은 정산되지 않은 영업마감전 데이터로, 영업 마감후 정산처리가 완료되면 매출 내역은 달라질 수 있습니다.  (정산시간: 개점~마감 기준으로 다음날 이전일 영업중 데이터가 없을 때  ex) 5/15개점 ~ 5/16 마감시 5/15 매출 정산)",
            "시스템 정산 및 실시간 업데이트 데이터 반영은 약 5분 ~ 10분정도 소요될 수 있습니다."
        ],
        cafeBusiness: [
            "영업매출은 검색기간의 평균 데이터로 제공 되며, 요일별, 시간대별로 매출 비교가 가능 합니다.",
            "영업일 평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
            "실시간으로 업데이트된 영업일 (영업중) 매출은 정산되지 않은 영업마감전 데이터로, 영업 마감후 정산처리가 완료되면 매출 내역은 달라질 수 있습니다.  (정산시간: 개점~마감 기준으로 다음날 이전일 영업중 데이터가 없을 때  ex) 5/15개점 ~ 5/16 마감시 5/15 매출 정산)",
            "시스템 정산 및 실시간 업데이트 데이터 반영은 약 5분 ~ 10분정도 소요될 수 있습니다",
        ],
        cafeBusinessManufacturing: [
            "주문제조 통계는 정산이 완료된 데이터로 통계치를 반영합니다.",
            "제조상품 여부와 관계없이 판매되는 모든 상품을 평균치로 정상적인 주문 4단계를 거친 주문건만 제조시간 통계를 제공됩니다.",
            "주문취소건은 통계에서 제외, 주문완료이 완료된 건만 집계됩니다. (결제취소건 포함)",
            "해당 통계는 매장픽업 유형만 집계되며, 예약픽업/ 배달예약/ 로봇배송 등 전체 제조과정 시간 측정이 어려운 픽업유형은 제외 됩니다."
        ],
        orderManufactureTime: "1개의 주문건에 상품 수량 및 제조상품 여부와 관계없이, 주문건 1개를 기준으로 제조시간 평균 통계를 제공합니다.",
        productManufactureTime: "주문수, 제조상품 여부와 상관없이, 기간 동안 판매된 1개의 상품의 제조시간 평균 통계를 제공합니다. (1건 주문당 제조시간 통계 / 판매상품수)",
        robotProductMaxCount: "로봇배달이 가능한 최대 상품 수치를 설정합니다. 주문할 로봇배달 상품 수치가 설정된 값을 초과하면 로봇배달이 비활성화 됩니다.",
        robotLoadingTimeSeconds: "매장 주문대기중 상품 수 x N초로 계산되어 로봇에게 상차 가능시간을 전송합니다. 설정된 시간에 맞춰 로봇이 상차를 위해 매장에 방문합니다.",
        createQrMsg: "생성된 QR코드가 없습니다.",
        errorQrMsg: "QR생성에 실패했습니다.\n다시 시도해주세요.",
        productStatistics: [
            "총매출 = 상품의 판매로 발생된 전체 매출로 상품의 판매가격 + 옵션가 (할인가와 결제취소를 더하지 않은 매출)",
            "매출 = 총매출액 - (결제취소+할인조정액)",
            "영업일 평균 데이터는 검색기간별 매출합계와 shop별 영업일을 나눠 정산된 금액입니다.",
            "상품 판매가격이 변동된 경우 변동된 최종가격으로 표시되며, 매출액은 정산이 완료된 데이터로 판매된 일자의 상품가격을 따라 매출에 반영됩니다."
        ],
        opUserService: [
            "사용자 통계는 엘리가 오더를 1번이라도 사용한 이력이 있는 Active User 통계로, 등록된 임직원을 기준으로 중복값을 제외한 사용자 데이터로 제공됩니다.",
            "Active User는 매월 초 전달의 사용 이력을 기준으로 통계가 집계됩니다."
        ],
        brandSalesFormula: [
            "총매출 - (결제취소+할인조정액) = 매출",
            "매출비율은 전체 매출에서 법인별 매출을 100의 비율로 환산하여 표시됩니다.",
        ],
        diningSatisCourse: '만족도 평가를 진행할 코스는 1~3까지 설정 할 수 있습니다. (단일메뉴 코스만 지원 가능) ',
        inputNormalPrice: "일반 결제가를 입력 후 \n" +
            "사원 결제가 등록이 가능합니다.\n" +
            "\n" +
            "일반결제가 기준으로 사원 할인 조정액이 자동으로 산출됩니다.",
        noCourse: "등록된 코스 정보가 없습니다.\n" +
            "식단관리 > 코스에서 코스 정보를 입력해주세요.",
        cafeSalesItemByBusinessDate: '영업일 기준으로 정산이 되지 않은 전일자 또는 오늘자 데이터가 노출됩니다. (전일자 정산마감시간 : YYYY.MM.DD TT:MM:SS)',
        pointGiveAndInitSetting: '지급 및 초기화 설정을 변경합니다.',
        pointGiveDesc: [
            '1일 사용자에게 포인트가 ',
            '지급',
            '되며'
        ],
        pointInitDesc: [
            '1일 사용자가 보유하고 있는 포인트가 ',
            '초기화 ',
            '됩니다.'
        ],
        pointApplyDesc: '* 변경사항은 다음달부터 적용됩니다.',
        pointAmountSetting: '※ 회수는 띄어쓰기 없이 마이너스 표시로 입력해주세요. (ex. - 5000)',
        addPointTransactionTarget: '포인트를 지급/회수할 대상을 + 버튼을 눌러 추가해 주세요.',
        plzWriteReason: '사유를 입력해주세요.',
        pointMaxExceeded: '최대 1,000,000까지 입력 가능합니다.',
        pointMinExceeded: '최소 -1,000,000까지 입력 가능합니다.',
        pointZeroNotAllowed: '숫자 0은 입력할 수 없습니다.',
        useCompanyPoint: '법인별로 포인트를 부여합니다.',
        pointGiveOnlyCurrentEmployee: '* 현재 재직중인 임직원에게만 포인트가 부여됩니다. (휴직 제외)',
        pointSettingDesc: [
            '• 포인트는 지급하는 월 1일에 부여됩니다.',
            '• 변경한 설정값은 다음 달부터 적용됩니다.',
            '예시) 4/1 변경 → 5/1 부터 반영, 4/30 변경 → 5/1 부터 반영',
            '• 중도입사자와 같은 예외 인원들은 수동 지급 서비스를 이용해주시기 바랍니다.'

        ],
        pointLimit: '포인트 금액은 최대 1,000,000까지 입력 가능합니다.',
        pointExcelUploadDuplicateError: 'EXCEL에 중복되는 인원이 있어 포인트를 지급할 수 없습니다.\n아래 임직원을 다시 한 번 확인해주세요.',
    },
    placeholders: {
        plzInputSpaceName: "스페이스명을 입력해주세요.",
        plzInputBrandCode: "브랜드 코드를 입력해주세요.",
        plzInputBrandName: "브랜드명을 입력해주세요.",
        plzInputShopName: "매장명을 입력해주세요.",
        plzInputEmail: "이메일을 입력해주세요.",
        plzInputName: "이름을 입력해 주세요.",
        plzInputPassword: "비밀번호를 입력해 주세요.",
        plzInputRePassword: "비밀번호를 한 번 더 입력해 주세요.",
        plzInputNewPassword: "변경하실 비밀번호를 입력해주세요.",
        plzConfirmNewPassword: "입력하신 비밀번호를 다시 입력해주세요.",
        noWelfareServiceUse: "사용중인 복지 서비스가 없습니다.",
        noConnectionHistory: "연동 내역이 없습니다.",
        plzInputContent: "내용을 입력하세요.",
        plzInputSecond: "초단위로 입력해 주세요.",
        plzInputTitle: "타이틀을 입력하세요.",
        plzInputOption: "옵션 추가",
        plzInputQuestion: "질문을 입력해 주세요.",
        plzInputBasicAddress: 'basicAddress 정보를 입력해 주세요.',
        plzInputDetailAddress: 'detailAddress 정보를 입력해 주세요.',
        plzInputCategoryName: '카테고리명을 입력하세요.',
        plzInputGoodsGroupName: '그룹명을 입력하세요.',
        plzInputOptionName: '옵션명을 입력하세요.',
        plzInputPoint: '포인트 금액을 입력해주세요.',
        plzInputPointTransactionReason: '포인트 지급/회수 사유를 입력해주세요.',
    },
    comment: {
        plzCheckCardRegistered: "등록된 카드인지 확인해 주세요.",
        validCardNumber: "사용가능한 카드번호 입니다.",
        cardAlreadyRegistered: "이미 등록된 카드번호 입니다. 등록된 번호를 수정 후 입력해 주세요.",
        onlyUpperLowerEnglishNumberSpecial: "영문 대/소문자, 숫자와 특수기호(-)만 사용 가능합니다.",
        availableId: "사용 가능한 ID입니다.",
        usedId: "사용중인 ID 입니다.",
        confirmPassword: "* 비밀번호 일치",
        notConfirmPassword: "* 비밀번호가 일치하지 않습니다."
    },
    contentsDesc: {
        pickupBoardData: "픽업보드에는 POS에서 요청한 픽업 데이터가 노출됩니다.",
    },
    fileDesc: {
        fileSizeLimit: "파일은 최대 1GB까지만 지원 가능합니다.",
        brandImageResolution: "※ 이미지 파일 등록 (스페이스별 APP 로그인 페이지에 노출됩니다.)\n권장 해상도 : 945x120",
    },
    alert: {
        serverError: "서버 오류가 발생하였습니다.\n다시 시도해주세요.",
        deviceAllReboot: "선택하신 디바이스 전체 재부팅을 진행합니다.",
        devicePowerOff: "선택하신 디바이스의 전원을 OFF 하시겠습니까?",
        deviceStart: "선택하신 디바이스를 실행합니다.",
        deviceStop: "선택하신 디바이스를 중지합니다.",
        deviceUpdate: "선택하신 디바이스를 업데이트 하시겠습니까?",
        plzIdInput: "ID를 입력하세요.",
        plzRemoteIdCheck: "리모트 ID 중복 확인해 주세요.",
        plzCheckScreenShotPeriod: "스크린샷 주기를 입력해주세요",
        plzCheckAgentPeriod: "모니터링 주기를 입력해주세요",
        modifyComplete: "수정되었습니다.",
        reLogin: "비밀번호 변경시 다시 로그인해주세요.",
        nextDev: "지원하지 않는 서비스입니다.\n곧 지원할 수 있도록 노력하겠습니다.\n감사합니다.",
        noData: "데이터가 없습니다.\n관리자에 문의해주세요.",
        memberDelete: "멤버를 삭제하시겠습니까?",
        saveError: "저장에 실패했습니다.\n다시 시도해주세요.",
        saveSuccess: "저장되었습니다.",
        uploadSuccess: "업로드 성공했습니다.",
        uploadError: "업로드 실패했습니다. 다시 시도해주세요.",
        deleteError: '삭제에 실패했습니다.\n다시 시도해주세요.',
        deleteSuccess: '삭제되었습니다.',
        noCheckError: '선택된 데이터가 없습니다.',
        useCompanyPriceConfrim: '상품 가격을 법인별로 설정하시겠습니까?\n설정값이 변경되면 상품 가격이 초기화 됩니다.',
        unUseCompanyPriceConfrim: '사원 판매가를 통합으로 설정하시겠습니까?\n설정값이 변경되면 상품 가격이 초기화 됩니다.',
        plzTitleAndContent: '제목과 내용은 필수 입니다.',
        isSave: "저장하시겠습니까?",
        plzInputCompanyCodeAndName: "코드와 법인명(KOR)은 필수 입니다.",
        plzCheckAllInput: '필수입력값을 확인하세요.',
        plzCheckGoodsPrice: '금액 설정을 다시 확인해주세요.',
        stockCannotBeNegative: '재고 전체 수량은 0개 이상이어야 합니다.',
        surveyLastSelection: '최소 1개의 답변이 필요합니다',
        isDelete: '선택한 데이터를 삭제하시겠습니까?',
        isSurveyClose: '설문조사를 종료하시겠습니까?',
        saveStateSuccess: '상태 변경이 완료되었습니다.',
        saveStateError: '상태 변경에 실패하였습니다.',
        isCancel: '취소하시겠습니까?\n페이지를 벗어나면 작성한 내용이 저장되지 않습니다.',
        idcardPriceOverNormal: '사원판매가가 일반판매가보다 높습니다.',
        idcardPriceMinus: '사원판매가는 0원 이상이어야 합니다.',
        normalPriceMinus: '일반판매가는 0원 이상이어야 합니다.',
        menuGroupDelete: '메뉴그룹을 삭제하시겠습니까?',
        menuGroupDeleteDesc: '그룹에 등록된 하위메뉴 키워드가 삭제되며,\n해당 키워드로 push 알림이 발송되지 않습니다.',
        robotKmListError: '하차지 정보를 정상적으로 불러오지 못했습니다.\n다시 한번 시도해 주세요.',
        updateRobotKmList: '하차지 정보를 업데이트합니다.\n기존에 설정된 하차지 정보는 초기화됩니다.\n(QR코드 및 사용여부 초기화)',
        categoryDelete: '선택한 카테고리를 삭제하시겠습니까?',
        goodsGroupDelete: '선택한 상품그룹을 삭제하시겠습니까?',
        optionDelete: '선택한 옵션 상품을 삭제하시겠습니까?',
        needNormalPrice: '일반 판매가를 먼저 입력해주세요.',
        useStock: '재고관리를 사용하시겠습니까?',
        useStockDesc: '상품의 입/출고 내역을 관리하며\n상품 재고가 0일 경우 자동으로 품절 처리 됩니다.',
        unUseStock: '재고관리 사용을 중지하시겠습니까?',
        unUseStockDesc: '재고관리 사용을 중지하는 경우 설정된 옵션과 누적 통계가 초기화되며, 재설정이 필요합니다.',
        displayCopy: '선택한 전시 상품을 복사하시겠습니까?',
        displayCopyDesc: '개의 전시 상품이 새로운 이름으로 생성됩니다.',
        displayDelete: '선택한 전시 상품을 삭제하시겠습니까?',
        displayDeleteDesc: '개의 전시 상품이 삭제되어 키오스크와 APP에 노출되지 않습니다.',
        noGoods: '상품은 필수값입니다.',
        goodsCopy: '선택한 상품을 복사하시겠습니까?',
        goodsCopyDesc: '개의 상품이 새로운 이름으로 생성됩니다.',
        goodsDelete: '선택한 상품을 삭제하시겠습니까?',
        singleFile: '파일은 1개만 가능합니다.',
        maxThreeMonth: '최대 3개월 기간으로 설정해 주세요.',
        maxTwoMonth: '최대 2개월 기간으로 설정해 주세요.',
        cafeteriaOpen: '영업을 시작하시겠습니까?',
        cafeteriaClose: '영업을 종료하시겠습니까?',
        plzInputName: '이름을 입력해주세요.',
        plzInputPassword: '비밀번호를 확인해주세요.',
        wrongPassword: '비밀번호가 일치하지 않습니다.\n비밀번호를 확인해주세요.',
        requiredTitleFile: "제목, 파일첨부는 필수입니다.",
        shopAddSuccess: 'shop을 등록했습니다.',
        shopPickupType: '하나 이상의 픽업 유형은 필수로 선택해야 합니다.',
        deviceDisconnect: '연결을 해제하시겠습니까?',
        robotDeliveryVolumeCheck: '로봇 배달을 원하실 경우 \n상품에 로봇배달 수치를 입력해 주세요.',
        stopAutoPoint: '포인트 자동 지급을 중지하시겠습니까?',
        stopAutoPointDesc: '변경 시 다음 달 부터 포인트 자동 지급 및 초기화가 중지됩니다.',
        useAutoPoint: '포인트 자동 지급을 사용하시겠습니까?',
        useAutoPointDesc: '변경 시 다음 달 부터 포인트 자동 지급 및 초기화가 적용됩니다.',
        pointManualApplyFail: 'EXCEL 내용에 오류가 있어 포인트를 지급할 수 없습니다.\n파일 내용을 다시 한 번 확인해주세요.',
        writePointTransactionReason: '포인트 지급/회수 사유를 입력해 주세요.',
        duplicateFileName: '동일한 파일명은 다시 업로드할 수 없습니다.',
        saveSetting: '설정을 저장하시겠습니까?',
        settingApplyNextMonth: '변경된 내용은 다음 달 부터 적용됩니다.',
        uploadLimitExceeded: '1개의 엑셀 파일 내 수기매출 건은\n최대 1,000건까지만 업로드 가능합니다.',
        doExcelDownload: '엑셀파일을 다운로드 합니다.',
        excelDownloadFailByTimeout: '요청 건수가 많아 다운로드에 실패했습니다.\n기간 검색 조건을 좁혀 다시 시도해주세요.',
        waitForShopCopy: '현재 Shop 상품 복사가 진행중입니다.\n상품 복사가 완료된 후 다시 시도해주세요.',
        shopCopyFin: '상품 복사가 완료되었습니다.',
        invalidatePublishDate: '게시일자를 확인해주세요.',
        publishDateRequest: '일자를 설정해주세요.\n즉시 버튼 선택 시 저장과 동시에 게시됩니다.',
        invalidatePushDate: 'Push 알림일자를 확인해주세요.',
        datePast: '현재 시점보다 이전인 경우 저장할 수 없습니다.',
        certifySuccess: '인증에 성공했습니다.',
        certifyError: '인증에 실패했습니다.',
        minLengthThree: '최소 3글자 이상 입력해주세요.',
        uploadImageRatioError: '등록 가능한 이미지 사이즈가 아닙니다.\n가로, 세로 각 30픽셀 이상인 이미지만 등록이 가능합니다.',
        uploadExcelFile: '엑셀파일만 업로드 가능합니다.',
        goingToUploadExcel: '엑셀 업로드를 하시겠습니까?',
        employeeUploadError: '필수 입력 데이터가 누락되었거나,\n중복된 데이터가(사원번호, RFID, 이메일 계정) 있습니다.\n임직원 정보를 다시 확인해주세요.\n※ 오류 정보 붉은색 표시'
    },
    dataNotFound: '조회된 데이터가 없습니다.',
    chartShowMaximumDataExceed: '그래프는 {number}일(개) 데이터까지 제공됩니다.',
    reOrderCount: {
        index01: '1회',
        index02: '2회 이상',
        index03: '5회 이상',
        index04: '10회 이상',
        index05: '20회 이상',
        index06: '30회 이상',
        index07: '50회 이상',
        index08: '100회 이상',
    },
    employeeExcelMappingErrorText: {
        companyNotExist: '법인정보 없음',
        duplicateRfid: 'RFID 중복',
        emailHasBlank: '이메일 공백 포함',
        emailFormatError: '이메일 형식 오류',
    }
};
